{
  "columnResizer": "Преоразмеряване на колони",
  "loading": "Зареждане...",
  "loadingMore": "Зареждане на още...",
  "resizeColumn": "Преоразмеряване на колона",
  "sortAscending": "Възходящо сортиране",
  "sortDescending": "Низходящо сортиране "
}
